import React, { Component } from 'react';
import { PDFViewer, Page, Text, Image, Document, View, StyleSheet } from '@react-pdf/renderer';
import { ADMISION } from './Styles/StylesAdmision';
import { formatReconver } from "../../funciones/GeneralFunctions";

import logo from "../../assets/img/logo_menu_black.png";
class AlumnosMorosos extends Component {

    contenido = () => {
        let { datos, reg, datosNi } = this.props;

        const styles = StyleSheet.create(ADMISION[0]);

        let estudiantes = () => {
            if (reg === false) {
                if (datos.length === 0) return (
                    <View style={[styles.row]}>
                        <Text style={[styles.colTabla10, styles.font9, styles.bordeCol11, {textAlign: "center"}]}>No existen estudiantes morosos</Text>
                    </View>
                )

                return (
                    datos.map(option => (
                        <View key={option.id} style={[styles.row]}>
                            <Text style={[styles.colTablaList1, styles.font9, styles.bordeCol11]}>{option.Ci} - {option.Estudiante}</Text>
                            <Text style={[styles.colTablaList2, styles.font8, styles.bordeCol9, styles.center]}>{option.Carrera}</Text>
                            <Text style={[styles.colTablaList2, styles.font8, styles.bordeCol9, styles.center]}>{option.Deuda} Bs.</Text>
                        </View>
                    ))
                )
            }else{
                if (datosNi.length === 0) return (
                    <View style={[styles.row]}>
                        <Text style={[styles.colTabla10, styles.font9, styles.bordeCol11, {textAlign: "center"}]}>No existen estudiantes morosos</Text>
                    </View>
                )
    
                return (
                    datosNi.map(option => (
                        <View key={option.id} style={[styles.row]}>
                            <Text style={[styles.colTablaList1, styles.font9, styles.bordeCol11]}>{option.Ci} - {option.Estudiante}</Text>
                            <Text style={[styles.colTablaList2, styles.font8, styles.bordeCol9, styles.center]}>{option.Carrera}</Text>
                            <Text style={[styles.colTablaList2, styles.font8, styles.bordeCol9, styles.center]}>{option.Deuda} Bs.</Text>
                        </View>
                    ))
                )
            }
        }

        let deuda = () => {
            let total = 0;
            if (reg === false) {
                for (let i in datos) {
                    total += parseInt(datos[i].Deuda)
                }
            }else{
                for (let i in datosNi) {
                    total += parseInt(datosNi[i].Deuda)
                }
            }
            /* return `${formatNumber(total)} Bs. - ${formatReconver(total)} Bs.` */
            return `${formatNumber(total)} Bs.`
        }

        let total = () => {
            if (reg === false) return datos.length
            return datosNi.length
        }

        let formatNumber = (num) => {
            if (!num || num == 'NaN') return '-';
            if (num == 'Infinity') return '&#x221e;';
            num = num.toString().replace(/\$|\,/g, '');
            if (isNaN(num))
                num = "0";
            let sign = (num == (num = Math.abs(num)));
            num = Math.floor(num * 100 + 0.50000000001);
            let cents = num % 100;
            num = Math.floor(num / 100).toString();
            if (cents < 10)
                cents = "0" + cents;
            for (let i = 0; i < Math.floor((num.length - (1 + i)) / 3) ; i++)
                num = num.substring(0, num.length - (4 * i + 3)) + '.' + num.substring(num.length - (4 * i + 3));
            return (((sign) ? '' : '-') + num + ',' + cents);
        }

        return (
            <React.Fragment>
                <View style={styles.row}>
                    <Image
                        style={[styles.colContent40, styles.logo]}
                        src={logo}
                    />
                    <View style={[styles.colContent60, styles.header1Left,{marginTop: 14,}]}>
                        <Text style={[styles.Negrita]}>INSTITUTO UNIVERSITARIO DE DISEÑO LAS MERCEDES</Text>
                        <Text style={[styles.textPeq]}>REGISTRO M.E, Nº 130 G.O. Nº 36.719  9 JUNIO 1.999 | RIF.J-30583313-3</Text>
                    </View>
                </View>
                <Text style={[styles.titulo, styles.header1Right, styles.custonMt10, styles.customMl,
                    {fontSize: 14, backgroundColor: "#777", color:"#FFF", padding: 2, borderRadius: 2}]}>
                    LISTADO DE ALUMNOS MOROSOS
                </Text>

                <View style={[styles.bordeConstancia, {backgroundColor: "#FFF", padding: 4,}]}>
                    <Text style={[styles.font10, {backgroundColor: "#ccc"}]}>I. DATOS ESTADÍSTICOS</Text>
                    <View style={[styles.row, {padding: 5, backgroundColor: "#fff"}]}>
                        <Text style={[styles.col3, styles.font9, {textAlign: "justify"}]}>
                            Total de Estudiantes: {total()}
                        </Text>
                        <Text style={[styles.col3, styles.font9, {textAlign: "right", color: "#c60000"}]}>
                            Total de la Deuda: {deuda()}
                        </Text>
                    </View>
                </View>

                <View style={[styles.bordeConstancia, {marginTop: 5, backgroundColor: "#FFF"}]}>
                    <Text style={[styles.font10, {backgroundColor: "#ccc"}]}>II. LISTADO DE ESTUDIANTES</Text>
                    <View style={[{paddingLeft: 5, paddingTop: 5, backgroundColor: "#fff"}]}>
                        <View style={[styles.row]}>
                            <Text style={[styles.colTablaList1, styles.font9, styles.bordeCol11, styles.borderTop, {backgroundColor: "#777", color:"#FFF"}]}>Estudiante</Text>
                            <Text style={[styles.colTablaList2, styles.font9, styles.bordeCol9, styles.borderTop, styles.center, {backgroundColor: "#777", color:"#FFF"}]}>Carrera</Text>
                            <Text style={[styles.colTablaList2, styles.font9, styles.bordeCol9, styles.borderTop, styles.center, {backgroundColor: "#777", color:"#FFF"}]}>Deuda</Text>
                        </View>
                        {estudiantes()}
                    </View>
                </View>

                <View style={[styles.footer]}>
                    <View style={[styles.row]}>
                        <View style={[styles.col6]}>
                        <Text style={[styles.linea3]}></Text>
                            <Text style={[styles.encabezado2]}>
                                Av. Río de Janeiro con Calle Roraima, quinta Los Abuelos, N° 78, Urbanización Chuao, 
                                C.P.1061  Edo Miranda - Caracas - Venezuela
                            </Text>
                            <Text style={[styles.encabezado2, {marginTop: -5}]}>
                                Telefax: +58 212 9930983 | 9939139 | 9910710.
                            </Text>
                        </View>
                    </View>
                </View>
            </React.Fragment>
        )
    }

    render() {
        const styles = StyleSheet.create(ADMISION[0]);
        return (
            <PDFViewer style={styles.section}>
                <Document title="Alumnos Morosos">
                    <Page size="letter" style={styles.body}>
                        <View>
                            {this.contenido()}
                        </View>
                    </Page>
                </Document>
            </PDFViewer>
        );
    }
}
 
export default AlumnosMorosos;


// WEBPACK FOOTER //
// ./src/components/Reportes/AlumnosMorosos.jsx